export default __webpack_public_path__ + "static/media/res-logo.17a1d399.png";